import React from 'react';
import PropTypes from 'prop-types';

import styles from '../styles/badge.module.css'
import { APP_NAME } from '../constants';
import assets from '../assets';

const Badge = ({ type, url, disabled }) => {
	const icon = type === 'googleplay'
		? assets.badge.googleplay
		: assets.badge.appstore
	const text = type === 'googleplay'
		? 'Google Play Store'
		: 'Apple App Store'

	const imgClass = disabled
		? `${styles.badge} ${styles.disabled}`
		: styles.badge

	const linkProps = {
		className: disabled ? styles.disabled : "",
		href: disabled ? "#" : url,
		target: disabled ? "" : "__blank"
	}

	return (
		<a {...linkProps}>
			<img
				className={imgClass}
				src={icon}
				alt={`Download ${APP_NAME} on the ${text}"`}
			/>
		</a>
	);
}

Badge.propTypes = {
	type: PropTypes.oneOf(['googleplay', 'appstore']).isRequired,
	url: PropTypes.string.isRequired,
	disabled: PropTypes.bool
}

Badge.defaultProps = {
	disabled: false
}

export default Badge;